import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import MusicSection from './components/MusicSection';
import MixesSection from './components/MixesSection';
import AboutSection from './components/AboutSection';
import ConnectSection from './components/ConnectSection';
import BlogSection from './components/BlogSection';
import BlogPost from './components/BlogPost';
import Footer from './components/Footer';
import NotFoundPage from './components/NotFoundPage';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <MusicSection />
      <AboutSection />
      <ConnectSection />
    </>
  );
};

function App() {
  useEffect(() => {
    document.title = "DJ Landan Time | Multi-versed Music Producer and DJ";
    
    // Error boundary for unhandled errors
    const handleError = (event: ErrorEvent) => {
      console.error('Unhandled error:', event.error);
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-black text-white">
        <header>
          <Navbar />
        </header>
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <h1 className="sr-only">DJ Landan Time - Multi-versed Music Producer and DJ</h1>
                <HomePage />
              </>
            } />
            <Route path="/music" element={
              <>
                <div className="pt-24">
                  <MusicSection />
                </div>
              </>
            } />
            <Route path="/mixes" element={
              <>
                <div className="pt-24">
                  <MixesSection />
                </div>
              </>
            } />
            <Route path="/about" element={
              <>
                <div className="pt-24">
                  <AboutSection />
                </div>
              </>
            } />
            <Route path="/blog" element={
              <>
                <div className="pt-24">
                  <BlogSection />
                </div>
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <div className="pt-16">
                  <BlogPost />
                </div>
              </>
            } />
            <Route path="/connect" element={
              <>
                <div className="pt-24">
                  <ConnectSection />
                </div>
              </>
            } />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;